document.addEventListener('DOMContentLoaded', function () {
    const blockPosts = document.querySelectorAll('[data-latest-posts-block]');

    if (blockPosts.length === 0) return;

    blockPosts.forEach(function (blockPosts) {
        setupBlockPosts(blockPosts);
    });
});

function setupBlockPosts(blockPosts) {
    const blockPostsGrid = blockPosts.querySelector('[data-latest-posts-grid]');
    const blockPostsCards = blockPostsGrid ? Array.from(blockPostsGrid.querySelectorAll('[data-latest-posts-card]')) : [];
    const blockPostsLoadMore = blockPosts.querySelector('[data-latest-posts-load-more]');
    const blockPostsSelect = blockPosts.querySelector('[data-latest-posts-sort]');
    const blockPostsSelectButton = blockPosts.querySelector('[data-latest-posts-sort-button]');
    const blockPostsSelectLabel = blockPosts.querySelector('[data-latest-posts-sort-label]');
    const blockPostsSelectMenu = blockPosts.querySelector('[data-latest-posts-sort-menu]');
    const blockPostsSelectOptions = blockPosts.querySelectorAll('[data-latest-posts-sort-option]');
    const blockPostsPerPage = Number(blockPosts.getAttribute('data-latest-posts-per-page')) || 6;

    if (!blockPostsGrid || blockPostsCards.length === 0) return;

    let blockPostsVisibleCount = blockPostsPerPage;
    let blockPostsSort = blockPostsSelect ? blockPostsSelect.value : 'recent';

    const renderBlockPosts = function () {
        const sortedBlockPostsCards = blockPostsCards.slice().sort(function (blockPostsCardA, blockPostsCardB) {
            const blockPostsDateA = Number(blockPostsCardA.getAttribute('data-post-date')) || 0;
            const blockPostsDateB = Number(blockPostsCardB.getAttribute('data-post-date')) || 0;

            return blockPostsSort === 'oldest'
                ? blockPostsDateA - blockPostsDateB
                : blockPostsDateB - blockPostsDateA;
        });

        sortedBlockPostsCards.forEach(function (blockPostsCard, blockPostsIndex) {
            blockPostsGrid.appendChild(blockPostsCard);
            blockPostsCard.hidden = blockPostsIndex >= blockPostsVisibleCount;
        });

        if (blockPostsLoadMore) {
            blockPostsLoadMore.hidden = blockPostsVisibleCount >= sortedBlockPostsCards.length;
        }
    };

    const setBlockPostsSort = function (blockPostsNextSort) {
        blockPostsSort = blockPostsNextSort;
        blockPostsVisibleCount = blockPostsPerPage;

        if (blockPostsSelect) {
            blockPostsSelect.value = blockPostsSort;
        }

        blockPostsSelectOptions.forEach(function (blockPostsSelectOption) {
            const blockPostsOptionIsActive = blockPostsSelectOption.value === blockPostsSort;
            blockPostsSelectOption.classList.toggle('is-active', blockPostsOptionIsActive);
            blockPostsSelectOption.setAttribute('aria-selected', blockPostsOptionIsActive ? 'true' : 'false');

            if (blockPostsOptionIsActive && blockPostsSelectLabel) {
                blockPostsSelectLabel.textContent = blockPostsSelectOption.textContent;
            }
        });

        renderBlockPosts();
    };

    const closeBlockPostsMenu = function () {
        if (!blockPostsSelectMenu || !blockPostsSelectButton) return;

        blockPostsSelectMenu.hidden = true;
        blockPostsSelectButton.setAttribute('aria-expanded', 'false');
    };

    if (blockPostsLoadMore) {
        blockPostsLoadMore.addEventListener('click', function () {
            blockPostsVisibleCount += blockPostsPerPage;
            renderBlockPosts();
        });
    }

    if (blockPostsSelect) {
        blockPostsSelect.addEventListener('change', function () {
            setBlockPostsSort(blockPostsSelect.value);
        });
    }

    if (blockPostsSelectButton && blockPostsSelectMenu) {
        blockPostsSelectButton.addEventListener('click', function () {
            const blockPostsMenuIsOpen = !blockPostsSelectMenu.hidden;

            blockPostsSelectMenu.hidden = blockPostsMenuIsOpen;
            blockPostsSelectButton.setAttribute('aria-expanded', blockPostsMenuIsOpen ? 'false' : 'true');
        });
    }

    blockPostsSelectOptions.forEach(function (blockPostsSelectOption) {
        blockPostsSelectOption.addEventListener('click', function () {
            setBlockPostsSort(blockPostsSelectOption.value);
            closeBlockPostsMenu();
        });
    });

    document.addEventListener('click', function (event) {
        if (!blockPosts.contains(event.target)) {
            closeBlockPostsMenu();
        }
    });

    renderBlockPosts();
}
